import aiTools from "./resources/aiTools"
import analytics from "./resources/analytics"
import applicationForm from "./resources/applicationForm"
import assessments from "./resources/assessments"
import assignments from "./resources/assignments"
import auth from "./resources/auth"
import batch from "./resources/batch"
import bePracticeInterview from "./resources/bePracticeInterview"
import cpat from "./resources/cpat"
import credentials from "./resources/credentials"
import discussions from "./resources/discussions"
import enrollmentAgreements from "./resources/enrollmentAgreements"
import feedback from "./resources/feedback"
import global from "./resources/global"
import growthspace from "./resources/growthspace"
import itoAssessment from "./resources/ito/assessments"
import itoReferAndEarn from "./resources/ito/referAndEarn"
import itoRegistrations from "./resources/ito/registrations"
import itoReports from "./resources/ito/reports"
import jobs from "./resources/job"
import learningItems from "./resources/learningItems"
import masterclasses from "./resources/masterclasses"
import notifications from "./resources/notifications"
import offerLetter from "./resources/offerLetter"
import orders from "./resources/orders"
import payment from "./resources/payment"
import products from "./resources/products"
import profile from "./resources/profile"
import profileStrength from "./resources/profile/profileStrength"
import references from "./resources/references"
import sales from "./resources/sales"
import schedule from "./resources/schedule"
import settings from "./resources/settings"
import subscriptions from "./resources/subscriptions"
import suraasaPlus from "./resources/suraasaPlus"
import tia from "./resources/tia"
import users from "./resources/users"

const API = {
  discussions,
  assignments,
  masterclasses,
  feedback,
  users,
  assessments,
  auth,
  ito: {
    assessments: itoAssessment,
    reports: itoReports,
    referAndEarn: itoReferAndEarn,
    registrations: itoRegistrations,
  },
  profile: {
    ...profile,
    strength: profileStrength,
  },
  credentials,
  settings,
  global,
  orders,
  subscriptions,
  learningItems,
  applicationForm,
  schedule,
  payment,
  notifications,
  aiTools,
  tia,
  batch,
  sales,
  products,
  references,
  analytics,
  cpat,
  suraasaPlus,
  jobs,
  offerLetter,
  growthspace,
  enrollmentAgreements,
  bePracticeInterview,
}

export default API
